import { render, staticRenderFns } from "./TheAboutHeader.vue?vue&type=template&id=ebac9472&scoped=true&"
import script from "./TheAboutHeader.vue?vue&type=script&lang=js&"
export * from "./TheAboutHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheAboutHeader.vue?vue&type=style&index=0&id=ebac9472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebac9472",
  null
  
)

export default component.exports